exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.heading {\n  margin-left: 120px;\n  margin-bottom: 20px;\n}\n.container {\n  height: 100vh;\n  background: white;\n  width: 100%;\n}\n.col-3 {\n  display: grid;\n  margin-top: 10%;\n  margin-left: 30%;\n  justify-content: center;\n}\n.loginForm .form-actions button:hover{\n  color: #fff !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-832dff96","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/login/ResetPassword.vue
// module id = 214
// module chunks = 0